import { useEffect, useState } from 'react'

// Debounce a value — ideal for search-as-you-type inputs so we don't
// hammer the backend on every keystroke (and save mobile data).
export function useDebounce(value, delay = 250) {
  const [debounced, setDebounced] = useState(value)
  useEffect(() => {
    const t = setTimeout(() => setDebounced(value), delay)
    return () => clearTimeout(t)
  }, [value, delay])
  return debounced
}
